import React from "react";

function HandoverRouteState({ as: Element = "div", role = "status", title, message, children }) {
  return (
    <Element className="handover-route-state" role={role}>
      <h1>{title}</h1>
      {message && <p>{message}</p>}
      {children}
    </Element>
  );
}

export default HandoverRouteState;
